import {State} from '../store';

export const getLastSeenElementForJob = (state: State, jobID: JobID): FileID|undefined => (
    state.lastSeenElement.activeFile[jobID]
);

export const getIdOfLastSeenAlbum = (state: State): JobID|undefined => state.lastSeenElement.currentAlbum;
